<script setup lang="ts">
import { Sizes } from '@ui/styles'

withDefaults(
  defineProps<{
    size?: typeof Sizes.R2D2 | typeof Sizes.Leia
    type?: 'horizontal' | 'vertical'
    variant?: 'light' | 'base' | 'dark' | 'accent'
  }>(),
  {
    size: Sizes.R2D2,
    type: 'horizontal',
    variant: 'light',
  },
)
</script>

<template lang="pug">
.divider(:class="[size, type, variant]")
</template>

<style scoped>
.divider {
  &.horizontal {
    --uno: w-100p;

    &.r2d2 {
      --uno: h-1;
    }

    &.leia {
      --uno: h-2;
    }
  }

  &.vertical {
    /* --uno: h-100p; */

    &.r2d2 {
      --uno: w-1;
    }

    &.leia {
      --uno: w-2;
    }
  }

  &.light {
    background: var(--cue-border-neutral-primary);
  }

  &.base {
    background: var(--cue-border-neutral-secondary);
  }

  &.dark {
    background: var(--cue-border-neutral-tertiary);
  }

  &.accent {
    background: var(--cue-border-accent-soft);
  }
}
</style>
